import { Inject, Injectable, Injector } from '@angular/core';



@Injectable({ providedIn: 'root' })
export class InventoryCounts_ReportService {

  constructor(
    private injector: Injector
  ) {
  }

  public InventoryCounts: InventoryCounts_ReportService = this;

  // injecting lazily in order to avoid circular dependencies
}

